/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-02, 14:57:46
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 11:26:41
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Vue from 'vue';
import Vuex from 'vuex';

// MODULES /////////////////////////////////////////////////////////////////////
import Subscriber from './modules/Subscriber';
import Recharges from './modules/Recharges';
import Billing from './modules/Billing';
import Brand from './modules/Brand';
import Help from './modules/Help';
import App from './modules/App';
import Payments from './modules/PaymentsAndInvoices';
import Complains from './modules/Complains';
import Services from './modules/Services';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Subscriber,
    App,
    Recharges,
    Billing,
    Brand,
    Help,
    Payments,
    Complains,
    Services,
  },
  strict: !process.env.DEBUG_MODE,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js